import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BugReport } from '../models/bug-report';
import { Observable } from 'rxjs';
import { FileUploadService } from 'src/app/shared-module/services';

const routes = {
  getAllBugReports: "/v1/bug-report/list",
  reportBug: "/v1/bug-report/report",
  resolveBugReport: "/v1/bug-report/resolve/",
  unresolveBugReport: "/v1/bug-report/unresolve/"
}

@Injectable({
  providedIn: 'root'
})
export class BugReportService {

  constructor(
    private http: HttpClient,
    private fileUploadService: FileUploadService
  ) { }

  getAll(): Observable<any> {
    return this.http.get(`${routes.getAllBugReports}`)
  }

  report(bugReport: BugReport, attachments: File[]): Observable<any> {
    let currentUrl = window.location.href;
    // Remove everything from the '(' character onwards
    const parenthesisIndex = currentUrl.indexOf('(');
    if (parenthesisIndex !== -1) {
      currentUrl = currentUrl.substring(0, parenthesisIndex);
    }
    bugReport.form.url = currentUrl;
    const formData = new FormData();

    if (attachments?.length)
      this.fileUploadService.uploadBugReportAttachments(attachments, bugReport);

    formData.append('id', bugReport.id);
    formData.append('deal', JSON.stringify(bugReport.deal));
    formData.append('vehicle', JSON.stringify(bugReport.vehicle));
    formData.append('tags', JSON.stringify(bugReport.tags));
    formData.append('form', JSON.stringify(bugReport.form));
    return this.http.post(routes.reportBug, formData);
  }

  resolveBugReport(id: string): Observable<any> {
    return this.http.get(routes.resolveBugReport + id);
  }

  unresolveBugReport(id: string): Observable<any> {
    return this.http.get(routes.unresolveBugReport + id);
  }
}
